'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const ensureArray = (value) => Array.isArray(value) ? value : [value];

exports.ensureArray = ensureArray;
//# sourceMappingURL=ensureArray.cjs.js.map
